// SpecializedInHomeSupportSection.js
import React from 'react';
import specializedInHomeSupportImage from '../assets/specialized-in-home-support-image.jpg';

const SpecializedInHomeSupportSection = () => {
  const services = [
    'Safe transitions from hospital or rehab to home',
    'Emotional support and companionship for both clients and families',
    'Assistance for those living with long-term or chronic illnesses',
    'Care for individuals managing Parkinson\'s disease or other neurological conditions',
    'Support for adults living with physical or cognitive disabilities'
  ];

  return (
    <section className="bg-cream py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

        {/* Left Image */}
        <div className="relative">
          <img
            src={specializedInHomeSupportImage}
            alt="A carer embracing an older woman"
            className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
          />
        </div>

        {/* Right Content */}
        <div>
          <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
            Specialty Care
          </p>
          <h3 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl mb-6">
            Specialised In-Home Support for Recovery and Long-Term Care
          </h3>

          <div className="space-y-4 text-muted text-base leading-relaxed mb-6 max-w-lg">
            <p>
              Managing a health challenge or settling back in after a hospital stay can feel overwhelming without the right support. At Wei Care, our specialty care is here to make that journey smoother, safer, and more comfortable. Whether you are recovering from surgery, living with a disability, or managing a long-term condition, our trained carers provide attentive, compassionate support that encourages independence and brings peace of mind.
            </p>

            <p className="text-ink font-medium">We assist clients across a wide range of needs, including:</p>
          </div>

          <ul className="space-y-3 max-w-lg">
            {services.map((service, index) => (
              <li key={index} className="flex items-start gap-3">
                <span className="shrink-0 mt-[0.55rem] w-1.5 h-1.5 rounded-full bg-primary" />
                <span className="text-muted text-sm leading-relaxed">{service}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SpecializedInHomeSupportSection;
